import React, { useEffect, useState, useRef } from "react";
import { Grid, Switch } from "@material-ui/core";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Card from "@mui/material/Card";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import CardActionArea from "@mui/material/CardContent";
import { useLocation } from "react-router-dom";
import { set } from "lodash";
import { useTranslation } from "react-i18next";



const DICT_REPORTS_AVAILABLES = {
  'UCMv1': {
    'label': "Usuario contra maquina v1",
    'url_general': "https://metabase.mvazquez.es/public/dashboard/4c84f17b-c0fa-4a9b-b49c-65330a5709e3",
    'url_detail': 'https://metabase.mvazquez.es/public/dashboard/3525cf5f-7947-48ee-a533-037ef0539446'
  },
  'UCMv2': {
    'label': "Usuario contra maquina v2",
    'url_general': "https://metabase.mvazquez.es/public/dashboard/743089f9-2c42-4b86-9710-75b941c69438",
    'url_detail': 'https://metabase.mvazquez.es/public/dashboard/56a01d96-3510-414b-854d-4bbcbb0d9c34'
  },
  'MYS': {
    'label': "Mueve tu esqueleto",
    'url_general': "https://metabase.mvazquez.es/public/dashboard/0f102b77-bdbe-4a75-89d3-8503888d6f48",
    'url_detail': 'https://metabase.mvazquez.es/public/dashboard/5f02fb4d-072e-4b66-8651-20e26252f8b0'
  }
}

const REPORTS_TYPES = ['General', 'Detallado']

export function Reports() {

  const list_session = Object.keys(DICT_REPORTS_AVAILABLES);
  const [reportSelected, setReportSelected] = useState("");
  const [typeSelected, setTypeSelected] = useState("url_general");   // "url_general" or "url_detail"
  const { t } = useTranslation("global")

  async function clickSession(event) {
    const session_selected = event.target.value;
    // console.log("🚀 ~ file: ReportsData.js:72 ~ clickSession ~ session_selected:", session_selected)
    setReportSelected(session_selected)
    setTypeSelected("url_general")
  }

  async function clickTypeReport(event) {
    const type_selected = event.target.value;
    // console.log("🚀 ~ file: ReportsData.js:72 ~ clickSession ~ session_selected:", type_selected)
    setTypeSelected(type_selected)
  }

  const location = useLocation();
  useEffect(() => {
    if (location.src === '/versusMachine'){
      setReportSelected('UCMv1')
    }
    if (location.src === '/versusMachine2'){
      setReportSelected('UCMv2')
    }
    if (location.src === '/moveYourSkeleton'){
      setReportSelected('MYS')
    }
    setTypeSelected('url_general')
  }, [location]);

  function toggleSide() {
    setSwitchSide((side) => !side);
  }

  return (
    <HomeWrapper>
      <PageTitle title= {t("sReports.title").toUpperCase()} />
      <Grid className={`sig_DataSet_Root`} container>
        <Card style={{marginTop: '30px'}} className="sig_DataSet_CardContainer">
          <CardActionArea className={`sig_DataSet_CardActionArea`}>
            <FormControl className={`sig_DataSet_SetSelectionForm sig_DataSet_ExpandedForm`}>
              <InputLabel>{t("sReports.report")}</InputLabel>
              <Select className="sig_DataSet_MenuList" value={reportSelected} label="Sesion" onChange={clickSession}>
                  <MenuItem className="sig_DataSet_MenuListItem" value="">
                    <em> {t("strButton.no_selection")} </em>
                  </MenuItem>
                  {list_session.map((item) => {
                    return (
                    <MenuItem className="sig_DataSet_MenuListItem" key={item} value={item}>
                    {DICT_REPORTS_AVAILABLES[item]['label']}
                    </MenuItem>
                  );
                  })}
              </Select>
              {reportSelected !== ""  ?
                <Select className="sig_DataSet_MenuList" value={typeSelected} label="Sesion" onChange={clickTypeReport}>
                    <MenuItem className="sig_DataSet_MenuListItem" value="url_general">
                      <em> {t("sReports.general")} </em>
                    </MenuItem>
                    <MenuItem className="sig_DataSet_MenuListItem" value="url_detail">
                      <em> {t("sReports.table_filters")} </em>
                    </MenuItem>
                </Select>
              : <></>}

            </FormControl>
          </CardActionArea>
          {reportSelected !== "" ?
            <Paper elevation={3} style={{'top': '-20px'}} className="sig_VersusMachine_PaperInfo">
                <div className="sig_SignModal_PaperInfo">
                  <div className="sig_SignModal_PaperLine">
                    <span className="sig_VersusMachine_InfoTitle"> {t("strButton.notice")}  </span>
                    <span className="sig_VersusMachine_InfoContent">
                      {t("sReports.error_info")}
                      <Link href={DICT_REPORTS_AVAILABLES[reportSelected][typeSelected]} target="_blank" > {t("strButton.link_here")} </Link>
                    </span>
                  </div>
                </div>
              </Paper>
              
          :
          <></>
          }


        </Card>  
        {reportSelected !== "" ?
          <>
            <iframe
              src={DICT_REPORTS_AVAILABLES[reportSelected][typeSelected]}
              frameborder="1"
              width="100%"
              height="100%"
            />   
            {/* <iframe
              src={DICT_REPORTS_AVAILABLES[reportSelected]['url_detail']}
              frameborder="1"
              width="100%"
              height="100%"
            />   */}
          </>

        :
        <></>
        }
        
      </Grid>
      
          
      
    </HomeWrapper>
  );
  }
